/**
*
* SubTopics
*
*/

import React from 'react';
// import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { shorten } from 'utils/strings.js';
import ListTopics from './ListTopics.jsx';
import ConversationsBackButton from '../ConversationsBackButton.jsx';
import useConversationsContext from '../useConversationsContext.js';

function SubTopics() {
  const { inboxId, topics, topic, parentTopic } = useConversationsContext();
  return (
    <>
      <Card.Header className="d-flex justify-content-start border-bottom-0 mb-3 align-items-center">
        <ConversationsBackButton />
        <h2 className="card-title"><Link to={`/conversations/inboxes/${inboxId}/${parentTopic.id}`} className="text-gray">{shorten(parentTopic.title, 30)}</Link></h2>
      </Card.Header>
      <div className="flex-grow-1 overflow-auto">
        <ListTopics topics={{ ...topics, list: parentTopic.subTopicIds }} parentTopicId={parentTopic.id} activeId={topic.id} fixed />
      </div>
    </>
  );
}

export default SubTopics;
